import mfes from '../../../../cloud-ui-scripts/scripts/mfes.json';
import { Config } from '../config';

interface ResolveDeps {
  hostname: string;
  searchParams: URLSearchParams;
  sessionStorage: Storage;
  localDevSelectedEnv: string;
  isLocalMfe: (name: string) => boolean;
}

const resolveMfeUrls = (deps: ResolveDeps) => {
  const defaultHost = Config.DEFAULT_HOST;

  const result: Record<string, string> = {};

  for (const [name, { port }] of Object.entries(mfes as Record<string, { port: number }>)) {
    const sessionKey = `${name}_mfe_remote_url`;
    let url = `/cloud-ui-modules/${name}/entry.js`;

    if (!Config.IS_PRODUCTION) {
      if (deps.isLocalMfe(name)) {
        url = `https://test.${defaultHost}:${port}/assets/entry.js`;
      } else if (deps.searchParams.has(sessionKey)) {
        const remoteUrl = deps.searchParams.get(sessionKey) as string;
        try {
          deps.sessionStorage.setItem(sessionKey, remoteUrl);
        } catch {
          /* sessionStorage may be unavailable */
        }
        url = remoteUrl;
      } else {
        let storedUrl: string | null = null;
        try {
          storedUrl = deps.sessionStorage.getItem(sessionKey);
        } catch {
          /* sessionStorage may be unavailable */
        }
        if (storedUrl) {
          url = storedUrl;
        } else if (Config.IS_EXTERNAL_HOSTS) {
          url = `https://${Config.API_ENV}.${defaultHost}/cloud-ui-modules/${name}/entry.js`;
        }
      }
    }

    result[name] = url;
  }

  return result;
};

const getSearchParamsFromLocation = () => {
  let search: string;
  try {
    search = decodeURIComponent(window.location.search);
  } catch {
    search = window.location.search;
  }
  return new URLSearchParams(search);
};

const isLocalMfeFromEnv = (name: string) => {
  return process.env[`VITE_APP_LOCAL_${name.toUpperCase()}_MFE`] === 'true';
};

export const mfeUrls = resolveMfeUrls({
  hostname: window.location.hostname,
  searchParams: getSearchParamsFromLocation(),
  sessionStorage: window.sessionStorage,
  localDevSelectedEnv: process.env.VITE_APP_API_ENV || '',
  isLocalMfe: isLocalMfeFromEnv
});
